import { DocumentIcon, WhatsappIcon } from "@verde/icons";
import { Alert, Button } from "@verde/ui-core";
import React from "react";
import {
  AUTHORIZATION_KIND,
  useAuthorizationDialog,
} from "./authorization-dialog";
import type { AuthorizationKind } from "./types";

function AuthorizationDialogSelect() {
  const { setKind } = useAuthorizationDialog();

  return (
    <div className="grid gap-4">
      <Alert kind="warning">
        Para visualizar os dados de um produtor pela primeira vez é necessário
        obter autorização do mesmo.
      </Alert>

      <p className="text-base font-medium text-brand-green-dark">
        Envie um link de autorização para o Whatsapp do seu cliente. Ou anexe
        uma autorização por escrito feita pelo produtor.
      </p>

      <div className="grid gap-2 rounded bg-neutral-light-1 p-4">
        {Object.entries(AUTHORIZATION_KIND)
          .filter(([key]) => !["default", "success"].includes(key))
          .map(([key, value]) => {
            return (
              <Button
                key={`authorization-button-item-${key}`}
                size="lg"
                kind="secondary"
                icon={
                  {
                    attachment: <DocumentIcon />,
                    whatsapp: <WhatsappIcon />,
                  }[key] || undefined
                }
                onClick={() => setKind(key as AuthorizationKind)}
              >
                {value.title}
              </Button>
            );
          })}
      </div>
    </div>
  );
}

export default React.memo(AuthorizationDialogSelect);
